import { render, staticRenderFns } from "./UploadDocumentsList.vue?vue&type=template&id=0f652145&"
import script from "./UploadDocumentsList.vue?vue&type=script&lang=js&"
export * from "./UploadDocumentsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports